import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import { API } from "../App";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

/**
 * Paywall modal when council submit returns 402 (quota exhausted).
 */
const PaywallModal = ({ open, onOpenChange, checkoutEnabled, onDismiss }) => {
  const { t } = useLanguage();
  const [loadingProduct, setLoadingProduct] = useState(null);

  const startCheckout = async (product) => {
    if (!checkoutEnabled) {
      toast.error(t("billing.checkoutUnavailable"));
      return;
    }
    setLoadingProduct(product);
    try {
      const res = await axios.post(`${API}/billing/checkout`, { product });
      const url = res.data?.data?.checkout_url;
      if (url) {
        window.location.href = url;
        return;
      }
      toast.error(t("billing.checkoutError"));
    } catch (err) {
      toast.error(err.response?.data?.detail || t("billing.checkoutError"));
    } finally {
      setLoadingProduct(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{t("billing.paywallTitle")}</DialogTitle>
          <DialogDescription>{t("billing.paywallDesc")}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2 py-2">
          <Button
            type="button"
            onClick={() => startCheckout("payg")}
            disabled={!!loadingProduct}
            className="gap-2"
          >
            {loadingProduct === "payg" ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <CreditCard className="w-4 h-4" />
            )}
            {t("billing.buyOneCase")}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={() => startCheckout("monthly")}
            disabled={!!loadingProduct}
          >
            {loadingProduct === "monthly" ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : null}
            {t("billing.subscribeMonthly")}
          </Button>
        </div>
        <DialogFooter>
          <Button type="button" variant="ghost" onClick={onDismiss}>
            {t("common.cancel")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PaywallModal;
